import { render, staticRenderFns } from "./ClinicVideoDescription.vue?vue&type=template&id=47d7600e&"
import script from "./ClinicVideoDescription.vue?vue&type=script&lang=js&"
export * from "./ClinicVideoDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports